import { enableProdMode, ViewEncapsulation } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { AppLegacy} from './app-legacy/app.legacy';
import * as Sentry from '@sentry/browser';
import { User } from './app/resources/user/user.interface';

declare var angular: angular.IAngularStatic;

/**
 * Initialize Legacy app wrapper/setup.
 * Is needed for hybrid app.
 *
 * @note Linter marks this ass unused, but that's not true.
 */
// tslint:disable-next-line:no-unused-expression
new AppLegacy();

/**
 * Initialize and setup Sentry.
 *
 * Uses Cookies because it's available on app loading.
 */
const initSentry = () => {
  Sentry.init({
    dsn: 'https://9988895c64cd41f4b612fd64e292dcb4@sentry.io/1483727'
  });
  const cookie = `; ${document.cookie}`.match(`;\\s*user=([^;]+)`);
  const user: Partial<User> = cookie ? JSON.parse(decodeURIComponent(cookie[1])) : {};
  Sentry.configureScope(scope => {
    if (user && user._id) {
      scope.setUser({
        id: user._id.toString(),
        username: user.fullName,
        email: user.email
      });
    }
  });
};

/**
 * Initialize Production environment.
 */
if (environment.production) {
  initSentry();
  enableProdMode();
}

/**
 * Bootstrap App.
 */
const bootstrap = () => platformBrowserDynamic().bootstrapModule(AppModule);
bootstrap().catch(err => console.log(err));
